import script from "./CalculatorPageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculatorPageComponent.vue?vue&type=script&setup=true&lang=js"

import "./CalculatorPageComponent.vue?vue&type=style&index=0&id=4e5fac63&lang=css"

const __exports__ = script;

export default __exports__